module.exports = __webpack_public_path__ + "img/mask.4dd8e7a4.png";